<template>
  <div>
    <RightTitle title="充值记录"></RightTitle>
    <ChargeTab position="index"></ChargeTab>

    <!-- 搜索表单 -->
    <div class="uar_form">
      <el-form ref="form" :inline="true" :model="filter" label-width="80px" size="medium">
        <el-form-item label="单号">
          <el-input v-model="filter.orderid" clearable placeholder="搜索单号"></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="filter.status" clearable placeholder="请选择" style="width:120px;">
            <el-option value="1" label="已支付"></el-option>
            <el-option value="0" label="未支付"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search">搜索</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 数据表格 -->
    <div class="uar_form">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="innerNum" label="订单号"></el-table-column>
        <el-table-column prop="accountType" label="充值类型" width="80">
          <template slot-scope="scope">
            <span v-if="scope.row.accountType == 'vip'">VIP充值</span>
            <span v-else-if="scope.row.accountType == 'integral'">积分充值</span>
            <span v-else>其他充值</span>
          </template>
        </el-table-column>
        <el-table-column prop="money" label="充值金额" width="80"></el-table-column>
        <el-table-column prop="accountMoney" label="到账数量" width="80" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.accountType == 'vip'">-</span>
            <span v-else-if="scope.row.accountType == 'integral'">{{ scope.row.accountMoney }}</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="80" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 1">已支付</span>
            <span class="red" v-else>未支付</span>
          </template>
        </el-table-column>
        <el-table-column prop="addTime" label="订单时间" width="180" align="center"></el-table-column>
        <el-table-column prop="payTime" label="支付时间" width="180" align="center"></el-table-column>
      </el-table>
    </div>

    <!-- 分页 -->
    <div class="uar_form page_area">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="dataTotal"
        @current-change="currentChange"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
// 加载组件
import RightTitle from "../../components/RightTitle";
import ChargeTab from "../../components/ChargeTab";
// 加载api
import { chargeLog } from "../../api/charge";
// 加载函数
import { formatQuery } from "../../utils/fn";
export default {
  name: "charge_index",
  components: {
    RightTitle,
    ChargeTab
  },
  beforeRouteEnter(to, from, next) {
    chargeLog(to.query).then(res => {
      next(vm => {
        vm.tableData = res.data.list;
        vm.dataTotal = res.data.count;
      });
    });
  },

  beforeRouteUpdate(to, from, next) {
    chargeLog(to.query).then(res => {
      this.tableData = res.data.list;
      this.dataTotal = res.data.count;
    });
    next();
  },
  data() {
    return {
      filter: {
        orderid: "",
        status: ""
      },
      tableData: [],
      dataTotal: 0
    };
  },
  methods: {
    // 改变当前页
    currentChange(page) {
      this.$router.push({ query: { ...this.$route.query, page } });
    },
    // 搜索
    search() {
      this.$router.push({ query: { ...formatQuery(this.filter), page: 1 } });
    }
  }
};
</script>

<style scoped>
</style>